export default __webpack_public_path__ + "static/translator-application-d8e2adccd863f14e6262df0184d17618.png";